export default "__VITE_ASSET__CDp$DSqD__"